import React, { useState } from 'react'
import { ChevronDown, ArrowRight } from 'lucide-react'

const MOCK_ITINERARIES = [
  {
    title: '2 Days 1 Night',
    duration: '2 Days 1 Night',
    note: 'Most popular',
    link: null,
    days: [
      { day: 'Day 1', title: 'Hanoi → Halong Bay', content: 'Depart Hanoi (noon). Board at Tuan Chau Marina. Welcome lunch as we sail past iconic karsts. Afternoon kayaking, cave exploration. Sunset cocktails on deck. Dinner & overnight on bay.' },
      { day: 'Day 2', title: 'Halong Bay → Hanoi', content: 'Morning Tai Chi on deck. Breakfast with bay views. Check-out, final cruise through Halong highlights. Disembark at Tuan Chau (noon). Transfer back to Hanoi.' },
    ],
  },
  {
    title: '3 Days 2 Nights',
    duration: '3 Days 2 Nights',
    note: 'Best experience',
    link: null,
    days: [
      { day: 'Day 1', title: 'Hanoi → Halong Bay', content: 'Depart Hanoi (noon). Board at Tuan Chau Marina. Welcome lunch. Afternoon — floating village visit, squid fishing. Dinner & overnight.' },
      { day: 'Day 2', title: 'Halong Bay — Full Day', content: 'Full day on the bay. Morning kayaking to hidden lagoon. Cooking class — fresh spring rolls. Afternoon — beach visit on Ti Top Island. Stargazing after dinner.' },
      { day: 'Day 3', title: 'Halong Bay → Hanoi', content: 'Sunrise yoga. Breakfast. Check-out. Final scenic cruise. Disembark (noon). Transfer to Hanoi.' },
    ],
  },
]

function ItinGroup({ group }) {
  const [openIdx, setOpenIdx] = useState(null)

  return (
    <div className="sc-itin-group">
      <div className="sc-itin-group__header">
        <span className="sc-itin-group__title">{group.duration || group.title}</span>
        {group.note && (
          <span className="ljn-label" style={{ color: 'var(--color-gold)', fontSize: 10 }}>
            {group.note}
          </span>
        )}
      </div>

      <div className="sc-itin-days">
        {group.days.map((item, i) => (
          <div
            key={i}
            className={`sc-itin-item ${openIdx === i ? 'sc-itin-item--open' : ''}`}
            onClick={() => setOpenIdx(openIdx === i ? null : i)}
          >
            <div className="sc-itin-item__header">
              <span className="sc-itin-item__day">{item.day}</span>
              <span className="sc-itin-item__title">{item.title}</span>
              <ChevronDown size={15} className="sc-itin-item__arrow" />
            </div>
            <div className="sc-itin-item__body">
              <div dangerouslySetInnerHTML={{ __html: item.short_description }} />
            </div>
          </div>
        ))}
      </div>

      {group.link && (
        <div className="sc-itin-group__footer">
          <a href={group.link} className="sc-itin-group__link" target="_blank" rel="noopener noreferrer">
            View full itinerary
            <ArrowRight size={13} strokeWidth={1.5} />
          </a>
        </div>
      )}
    </div>
  )
}

// ACF field 'itineraries' — array of { title, note, link, days: [{ day, port, desc }] }
// 'link' comes from ACF relation field pointing to itinerary post (permalink)
export default function Itineraries({ itineraries }) {
  const groups = itineraries?.length ? itineraries : MOCK_ITINERARIES

  return (
    <section className="sc-section">
      <h2 className="ljn-section-title">Itineraries</h2>
      <div className="ljn-divider" style={{ marginBottom: 40 }} />
      <div className="sc-itins">
        {groups.map((g, i) => <ItinGroup key={i} group={g} />)}
      </div>
    </section>
  )
}
